export const roleTypes = {
  admin: {
    name: "ADMIN",
    i18n: "admin",
    i18nDesc: "adminDesc"
  },
  executive: {
    name: "EXECUTIVE",
    i18n: "executive",
    i18nDesc: "executiveDesc"
  },
  manager: {
    name: "MANAGER",
    i18n: "manager",
    i18nDesc: "managerDesc"
  },
  user: {
    name: "USER",
    i18n: "user",
    i18nDesc: "userDesc"
  },
  member: {
    name: "MEMBER",
    i18n: "member",
    i18nDesc: "memberDesc"
  }
};

export function getRoleTypeTranslation(roleName: string): string | null {
  for (const roleType in roleTypes) {
    if (roleTypes[roleType].name === roleName) {
      return roleTypes[roleType].i18n;
    }
  }
  return null;
}
